<template>
    <div class="aer-wrap">
        <div class="banner">
            <div class="intro-container">
                <div class="intro">
                    <div class="intro-title">
                        Android Enterprise Recommended devices for advanced security and flexibility
                    </div>
                    <div class="intro-content">
                      {{ introContent }}
                    </div>
                    <div class="intro-link">
                        <a href="https://www.android.com/enterprise/recommended/" target="_blank">
                            Learn more about Android Enterprise Recommended
                        </a>
                    </div>
                    <div class="intro-link">
                        <a href="https://www.android.com/enterprise/recommended/requirements/" target="_blank">
                            Google AER requirements
                        </a>
                    </div>
                    <div class="intro-footer">
                        <a href="##">
                          Google and ​Android​ ​are​ ​trademarks​ ​of​ ​Google​ ​LLC.
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!---小屏幕banner-->
        <div class="small-banner">

        </div>
        <div class="content">
            <div class="content-intro">
                <div class="content-wrap">
                    <div class="title">
                        The smarter way to grow your business
                    </div>
                    <div class="desc">
                        Android Enterprise Recommended devices allow your business to manage and enroll devices in a secure and efficient way.
                    </div>
                </div>
            </div>
            <ul class="content-card">
                <li>
                    <div class="aer-icon">
                        <img src="../assets/images/icon.png" alt="">
                    </div>
                    <div class="title">
                        Strict enterprise requirements
                    </div>
                    <div class="desc">
                      {{ desc }}
                    </div>
                    <div class="more">
                        <a href="https://www.android.com/enterprise/recommended/requirements/" target="_blank">Learn More</a>
                    </div>
                </li>
                <li>
                    <div class="aer-icon">
                        <img src="../assets/images/icon2.png" alt="">
                    </div>
                    <div class="title">
                        Flexible bulk device management
                    </div>
                    <div class="desc">
                      Empower productivity without compromising flexibility based on your business needs. Delivering consistent user experience for work profile and fully managed device provisioning, makes it easy to deployment. Allow your employee to get more work done in a more flexible and cost-effective way.
                    </div>
                    <div class="more">
                        <a href="https://www.android.com/enterprise/management/" target="_blank">Learn More</a>
                    </div>
                </li>
                <li>
                    <div class="aer-icon">
                        <img src="../assets/images/icon3.png" alt="">
                    </div>
                    <div class="title">
                        Android zero-touch enrollment
                    </div>
                    <div class="desc">
                      Android zero-touch enrollment is a fast, simple, and secure way to mobilize your employees. With zero-touch, you can deploy devices at scale with the apps they need and the security for your peace of mind.
                    </div>
                    <div class="more">
                        <a href="https://www.android.com/enterprise/enrollment/" target="_blank">Learn More</a>
                    </div>
                </li>
                <li>
                    <div class="aer-icon">
                        <img src="../assets/images/icon4.png" alt="">
                    </div>
                    <div class="title">
                       Timely system and security updates
                    </div>
                    <div class="desc">
                      Securing your device and maintaining the trust that you place in us is our top priority. Ensuring regular security updates and major OS upgrade support.
                    </div>
                    <div class="more">
                        <a href="https://www.android.com/enterprise/security/" target="_blank">Learn More</a>
                    </div>
                </li>
            </ul>
            <div class="content-product">
                <div class="title">
                    Business Phones
                </div>
                <ul class="product" ref="product">
                    <li class="product-item" v-for="(item, index) in modelList" :key="item.id" :class="{'focus-product': currentFocusIndex === index}" @mouseleave="handleModelPicUnfocus">
                        <div>
                            <img :src="item.picUrl" alt="" class="model-pic" @mouseenter="(e) => handleModelPicFocus(e, index)">
                        </div>
                        <div class="enterprise-icon">
                            <a :href="linkInfo.googleAerLink" target="_blank">
                                <img src="../assets/images/enterprise.png" alt="" width="106" height="43">
                            </a>
                        </div>
                        <div class="model-name">
                            {{item.externalModel}}
                        </div>
                        <div class="more">
                            <a :href="item.officialLink" target="_blank">
                                Learn more
                            </a>
                        </div>
                        <div :class="['desc', isLeft ? 'left-position' : 'right-position']" v-if="currentFocusIndex === index">
                            <div class="desc-item desc-model-name">
                                <span class="title">{{item.externalModel}}</span>
                                <span class="fr">
                                    <a :href="linkInfo.googleAerLink" target="_blank">
                                        <img src="../assets/images/enterprise.png" alt="" width="106" height="43">
                                    </a>
                                </span>
                            </div>
                            <div class="desc-item">
                                {{item.externalModel}} is an <a href="https://www.android.com/enterprise/devices/" class="link-color" target="_blank">
                                Android Enterprise Recommended device.
                            </a>
                            </div>
                            <div class="desc-item">
                                OS version update guaranteed up to: Android {{item.maxAndroidVer}}(Global)
                            </div>
                            <div class="desc-item">
                                Security MR guaranteed up to: {{item.secureMrDeadline}}(Global)
                            </div>
                            <div class="desc-item">
                                Recent security patches. <a :href="linkInfo.securePatchLink" class="link-color" target="_blank">See details</a>
                            </div>
                            <div>
                                <a :href="item.officialLink" class="link-color" target="_blank">Learn more</a>
                            </div>
                        </div>
                    </li>
                    <li class="product-item" v-if="modelList % 3 !== 0"></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from './api';

export default {
    name: '',
    data() {
        return {
            desc: `Devices submitted for certification will be thoroughly tested against Google's established practices and enterprise grade requirements for performance, consistency and security updates.`,
            introContent: `Android Enterprise Recommended devices are verified by Google to streamline the process of searching, evaluating and trouble-shooting to build out a successful mobility program that meets your business needs. vivo is a partner of Android Enterprise Recommended, which is a Google-led program that provides enterprises with industry-leading secure mobile experiences. vivo's partnership in the program ensures our customers have access to devices that offer outstanding performance and security.`,
            modelList: [],
            currentFocusIndex: '',
            isLeft: false,
            linkInfo: {}
        }
    },
    created() {
        this.getModelData();
    },
    methods: {
        getModelData() {
            api.modelData().then(res => {
                if (res.code === 200 && res.data) {
                    this.modelList = res.data.aerModelInfos || [];
                    this.linkInfo = res.data.commonInfo || {};
                }
            })
        },
        handleModelPicFocus(event, index) {
            const rect = event.target.getBoundingClientRect();
            this.isLeft = this.$refs.product.getBoundingClientRect().right - rect.right < 100;
            this.currentFocusIndex = index;
        },
        handleModelPicUnfocus() {
            this.currentFocusIndex = '';
        }
    }
}
</script>

<style scoped lang="scss">
    .aer-wrap{
        .link-color{
            text-decoration: none;
            font-weight: 400;
            line-height: 14px;
            color: #465AFF;
        }
        .banner{
            height: 820px;
            width: 100%;
            background-image: url(../assets/images/largeBanner.png);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-color: #F5F3EF;
            position: relative;
            .intro-container{
                max-width: 1200px;
                margin: 0 auto;
                height: 100%;
                position: relative;
                .intro{
                    width: 580px;
                    position: absolute;
                    top: 142px;
                }
            }
            .intro-title{
                line-height: 29px;
                font-size: 24px;
                font-weight: 400;
                margin-bottom: 32px;
            }
            .intro-content{
                font-size: 14px;
                line-height: 24px;
                color: #434343;
                margin-bottom: 32px;
            }
            .intro-link, .intro-footer{
                font-size: 12px;
                a{
                    text-decoration: none;
                    color: #465AFF;
                }
            }
            .intro-link{
                margin-bottom: 18px;
            }
            .intro-footer{
                margin-top: 42px;
            }
            .intro-footer a{
                color: #999999;
            }
        }
        .small-banner{
            display: none;
            height: 660px;
            width: 100%;
            background-image: url(../assets/images/smallBanner1.png);
            background-size: cover;
            background-repeat: no-repeat;
        }
        .content{
            margin: auto;
            max-width: 1452px;
            padding: 80px 0 140px 0;
            overflow: hidden;
            .content-intro{
                text-align: center;
                margin-bottom: 80px;
                .title{
                    font-size: 24px;
                    line-height: 29px;
                    font-weight: 400;
                    margin-bottom: 32px;
                }
                .content-wrap{
                    display: inline-block;
                    width: 765px;
                }
                .desc{
                    font-size: 14px;
                    line-height: 17px;
                    color: #999999;
                }
            }
            .content-card{
                margin-bottom: 76px;
                display: flex;
                justify-content: space-around;
                flex-wrap: wrap;
                li{
                    position: relative;
                    display: inline-block;
                    width: 335px;
                    height: 389px;
                    border-radius: 16px;
                    border: 1px solid #F2F2F2;
                    padding: 35px 28px 32px;
                    box-sizing: border-box;
                    text-align: center;
                    margin-bottom: 82px;
                    box-shadow: 0 2px 4px 0 rgba(204, 204, 204, 0.5);
                    .title{
                        font-size: 16px;
                        line-height: 22px;
                        margin-bottom: 32px;
                    }
                    .desc{
                        font-size: 14px;
                        line-height: 17px;
                        margin-bottom: 48px;
                        color: #999999;
                    }
                    .more{
                        position: absolute;
                        left: 117px;
                        top: 340px;
                    }
                    .more a{
                        font-size: 14px;
                        line-height: 22px;
                        color: #465AFF;
                        text-decoration: none;
                    }
                    .aer-icon{
                        margin-bottom: 32px;
                    }
                }
            }
            .content-product{
                .title{
                    text-align: center;
                    font-size: 24px;
                    line-height: 29px;
                    font-weight: 400;
                    margin-bottom: 124px;
                }
                .product{
                    width: 100%;
                    text-align: justify;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .product-item{
                        display: inline-block;
                        position: relative;
                        width: 233px;
                        box-sizing: border-box;
                        margin: 0 300px 54px 0;
                        text-align: center;
                        .enterprise-icon{
                            margin-top: 43px;
                        }
                        .model-name{
                            font-size: 24px;
                            line-height: 29px;
                            font-weight: 400;
                            margin: 9px 0 6px;
                        }
                        .model-pic{
                            width: 233px;
                            height: 233px;
                            /*object-fit: contain;*/
                        }
                        .more a{
                            font-size: 14px;
                            line-height: 17px;
                            font-weight: 400;
                            color: #465AFF;
                            text-decoration: none;
                        }
                        .desc{
                            position: absolute;
                            top: 0;
                            text-align: left;
                            width: 367px;
                            padding: 18px 8px 18px 20px;
                            font-size: 14px;
                            line-height: 17px;
                            font-weight: 400;
                            color: #333333;
                            background: #FFFFFF;
                            box-sizing: border-box;
                            border: 1px solid #F6F6F6;
                            border-radius: 14px;
                            box-shadow: 0 2px 4px 0 rgba(221, 221, 221, 0.5);
                            .desc-item{
                                line-height: 17px;
                                margin-bottom: 20px;
                            }
                            .desc-model-name{
                                .title{
                                    height: 42px;
                                    line-height: 42px;
                                }
                            }
                        }
                    }
                    .focus-product{
                        .desc{
                            left: 234px;
                        }
                        .left-position{
                            left: -368px;
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 1930px) {
            .product .product-item:nth-child(3n+3) {
                margin-right: 0!important;
            }
        }
        @media screen and (max-width: 1500px) {
            .content{
                max-width: 900px;
            }
            .banner{
                height: 700px;
            }
            .product .product-item{
                margin-right: 394px!important;
            }
            .product .product-item:nth-child(2n+2) {
                margin-right: 0!important;
            }
        }
        @media screen and (max-width: 1280px) {
            .banner{
                background-image: none;
                height: 570px;
                .intro-container .intro{
                    left:50%;
                    transform:translate(-50%,0);
                }
            }
            .small-banner{
                display: block;
                height: 976px;
            }
            .small-banner{
                display: block;
                height: 846px;
            }
        }
        @media screen and (max-width: 1080px) {
            .small-banner{
                height: 780px;
            }
        }
        @media screen and (max-width: 877px) {
            .product .product-item{
                margin-right: 310px!important;
            }
            .product-item .desc{
                width: 300px!important;
            }
            .focus-product .left-position{
                left: -300px!important;
            }
        }
        @media screen and (max-width: 818px) {
            .small-banner{
                height: 580px;
            }
            .content-intro .content-wrap{
                width: 90%!important;
            }
            .product .product-item{
                margin-right: 250px!important;
            }
            .product-item .desc{
                width: 240px!important;
            }
            .focus-product .left-position{
                left: -240px!important;
            }
        }
        @media screen and (max-width: 732px) {
            .product .product-item:nth-child(2n+2) {
                margin-right: 300px!important;
            }
            .product-item .desc{
                width: 394px!important;
            }
        }
        @media screen and (max-width: 640px) {
            .banner .intro-container .intro{
                width: 90%!important;
            }
            .small-banner{
                height: 480px;
            }
           .product-item .desc{
               width: 330px!important;
           }
        }
        @media screen and (max-width: 570px) {
            .banner{
                height: auto;
                padding: 142px 20px 0 20px;
                box-sizing: border-box;
                .intro-container .intro{
                    position: static;
                    transform: translate(0);
                    left: 0;
                }
            }
            .product-item .desc{
                width: 240px!important;
            }
        }
        @media screen and (max-width: 480px) {
            .product-item .desc{
                width: 240px!important;
            }
        }
    }
</style>
